export default __webpack_public_path__ + "static/media/technology.3c4b96a6.svg";